import { GetCountriesQuery } from '../../graphql/magento'
import { SelectFieldOption } from '../form'

type Countries = NonNullable<GetCountriesQuery['countries']>

export interface RegionSelectFieldOption extends SelectFieldOption {
  // fields selected from M2 Region type
  region: {
    id: number
    code: string
    name: string
  }
}

export const countrySelectOptionsFor = (countries: Countries): SelectFieldOption[] =>
  countries.reduce((acc: SelectFieldOption[], country) => {
    const { id: value, full_name_english: label } = country ?? {}
    if (value && label) {
      acc.push({
        value,
        label,
      })
    }
    return acc
  }, [])

export const regionSelectOptionsFor = (
  countries: Countries,
  countryCode: string,
  includeCodeInLabel = false,
): RegionSelectFieldOption[] => {
  const country = countries.find((c) => c?.id === countryCode)
  const availableRegions = country?.available_regions
  return (
    availableRegions?.reduce((acc: RegionSelectFieldOption[], region) => {
      const { id, code, name } = region ?? {}
      if (id != null && code && name) {
        acc.push({
          value: code,
          region: {
            id,
            code,
            name,
          },
          label: includeCodeInLabel ? `${name} (${code})` : name,
        })
      }
      return acc
    }, []) ?? []
  )
}
